<template>
  <div id="section8" class="page-section8">
    <div class="s8-inner fade-on-scroll">
      <h2 class="s8-title">Wedding Gift</h2>
      <p class="s8-desc">Doa restu Anda merupakan karunia yang sangat berarti bagi kami. Namun jika memberi adalah ungkapan tanda kasih Anda, Anda dapat memberikan hadiah secara cashless.</p>

      <div v-for="(bank, i) in bankList" :key="i" class="gift-card fade-on-scroll">
        <div class="gift-card-inner">
          <div class="gc-top">
            <div class="gc-bank-logo">
              <span class="gc-bank-name">{{ bank.nama }}</span>
            </div>
          </div>
          <div class="gc-separator"></div>
          <div class="gc-bottom">
            <button class="gc-copy-btn" :class="{ copied: bank.copied }" @click="copyNumber(bank, i)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
              </svg>
              <span>{{ bank.copied ? 'Tersalin!' : 'Copy' }}</span>
            </button>
            <div class="gc-number-info">
              <p class="gc-number">{{ bank.noAcc }}</p>
              <p class="gc-name">a.n {{ bank.accName }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Kado fisik placeholder -->
      <div v-if="client.gift_address" class="gift-card gift-card-physical fade-on-scroll">
        <div class="gift-card-inner gc-physical-inner">
          <div class="gc-top">
            <div class="gc-physical-icon">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#4a5c74" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 12 20 22 4 22 4 12"/>
                <rect x="2" y="7" width="20" height="5"/>
                <path d="M12 22V7"/>
                <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>
                <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
              </svg>
            </div>
          </div>
          <p class="gc-physical-label">Kado Fisik</p>
          <div class="gc-physical-address">
            <strong>Alamat:</strong>
            <div v-html="client.gift_address"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="copy-toast" :class="{ show: toastVisible }">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
      Nomor berhasil disalin!
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useInvitationStore } from '@/store';

export default {
  name: 'WeddingGiftSection',
  data() {
    return {
      banksCopied: [false, false, false, false],
      toastVisible: false,
      toastTimer: null,
    };
  },
  computed: {
    ...mapState(useInvitationStore, ['client']),
    bankList() {
      const c = this.client;
      const banks = [
        { nama: c.bank, noAcc: c.no_acc, accName: c.acc_bank },
        { nama: c.bank2, noAcc: c.no_acc2, accName: c.acc_bank2 },
        { nama: c.bank3, noAcc: c.no_acc3, accName: c.acc_bank3 },
        { nama: c.bank4, noAcc: c.no_acc4, accName: c.acc_bank4 },
      ].filter(b => b.nama && b.noAcc);
      return banks.map((b, i) => ({ ...b, copied: this.banksCopied[i] }));
    },
  },
  watch: {
    bankList(val) {
      if (val && val.length) {
        this.$nextTick(() => this.setupFadeObserver());
      }
    },
  },
  mounted() {
    this.setupFadeObserver();
  },
  beforeUnmount() {
    if (this._fadeObserver) this._fadeObserver.disconnect();
    if (this.toastTimer) clearTimeout(this.toastTimer);
  },
  methods: {
    async copyNumber(bank, index) {
      try {
        await navigator.clipboard.writeText(bank.noAcc);
      } catch {
        // fallback for older browsers
        const el = document.createElement('textarea');
        el.value = bank.noAcc;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }
      this.banksCopied = this.banksCopied.map((v, i) => i === index);
      this.showToast();
      setTimeout(() => {
        this.banksCopied = this.banksCopied.map(() => false);
      }, 2000);
    },
    showToast() {
      this.toastVisible = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => { this.toastVisible = false; }, 2200);
    },
    setupFadeObserver() {
      if (typeof IntersectionObserver === 'undefined') return;
      const observer = new IntersectionObserver(
        (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); }),
        { threshold: 0.15 }
      );
      this.$el.querySelectorAll('.fade-on-scroll').forEach(el => observer.observe(el));
      this._fadeObserver = observer;
    },
  },
};
</script>

<style scoped>
.fade-on-scroll { opacity: 0; transform: translateY(40px); transition: opacity 1s ease-out, transform 1s ease-out; }
.fade-on-scroll.is-visible { opacity: 1; transform: translateY(0); }

.page-section8 {
  background-image: url('~@/assets/images/cover1.jpeg'); background-size: cover; background-position: center;
  padding: 3rem 1.2rem 4rem; position: relative; overflow: hidden;
}
.page-section8::before { content: ''; position: absolute; inset: 0; background: rgba(255,255,255,0.75); z-index: 0; }
.page-section8 > * { position: relative; z-index: 1; }
.s8-inner {
  background: #4E637A; border-radius: 20px; padding: 2.5rem 1.5rem;
  display: flex; flex-direction: column; align-items: center; gap: 1.2rem; position: relative; overflow: hidden;
}
.s8-inner > * { position: relative; z-index: 1; }
.s8-title { font-family: 'Great Vibes', cursive; font-size: 3.5rem; font-weight: normal; color: #ffffff; text-align: center; margin-bottom: 0.2rem; }
.s8-desc { font-family: 'Cormorant Garamond', serif; font-size: 1.05rem; font-style: italic; color: rgba(255,255,255,0.9); text-align: center; line-height: 1.7; max-width: 380px; margin-bottom: 0.5rem; }
.gift-card { width: 100%; max-width: 420px; }
.gift-card-inner { background: #ffffff; border-radius: 16px; padding: 1.2rem 1.4rem 1rem; position: relative; overflow: hidden; box-shadow: 0 4px 16px rgba(0,0,0,0.18); }
.gc-top { display: flex; justify-content: flex-end; margin-bottom: 0.8rem; }
.gc-bank-logo { display: flex; align-items: center; }
.gc-bank-name { font-family: 'Cinzel', serif; font-size: 1.1rem; font-weight: 700; color: #1a3a5c; letter-spacing: 1px; }
.gc-separator { height: 1px; background: rgba(74,92,116,0.25); margin-bottom: 0.9rem; }
.gc-bottom { display: flex; align-items: center; justify-content: space-between; gap: 1rem; }
.gc-copy-btn {
  display: flex; align-items: center; gap: 6px; background: transparent; border: 1.5px solid rgba(74,92,116,0.5);
  color: #3d5068; font-family: 'Cormorant Garamond', serif; font-size: 0.95rem; font-weight: 600;
  padding: 0.45rem 0.9rem; border-radius: 8px; cursor: pointer; transition: background 0.25s, border-color 0.25s, transform 0.15s; flex-shrink: 0;
}
.gc-copy-btn:hover { background: rgba(74,92,116,0.1); border-color: #3d5068; }
.gc-copy-btn.copied { background: #3d7a3d; border-color: #3d7a3d; color: #ffffff; transform: scale(0.96); }
.gc-number-info { text-align: right; }
.gc-number { font-family: 'Cinzel', serif; font-size: 1.2rem; color: #2c3e50; font-weight: 600; letter-spacing: 1px; margin: 0; }
.gc-name { font-size: 0.85rem; color: #4a5c74; margin: 0.15rem 0 0; font-family: 'Cormorant Garamond', serif; font-style: italic; }
.gc-physical-inner { display: flex; flex-direction: column; align-items: center; gap: 0.6rem; padding: 1.4rem 1.4rem 1.2rem; text-align: center; }
.gc-physical-icon { width: 56px; height: 56px; background: rgba(74,92,116,0.1); border-radius: 50%; display: flex; align-items: center; justify-content: center; }
.gc-physical-label { font-family: 'Cinzel', serif; font-size: 1rem; color: #2c3e50; font-weight: 600; letter-spacing: 1px; margin: 0; }
.gc-physical-address { font-family: 'Cormorant Garamond', serif; font-size: 0.95rem; color: #4a5c74; line-height: 1.6; margin: 0; }
.copy-toast {
  position: fixed; bottom: 32px; left: 50%; transform: translateX(-50%) translateY(20px);
  background: #2ecc71; color: #ffffff; padding: 0.65rem 1.4rem; border-radius: 50px;
  font-family: 'Cinzel', serif; font-size: 0.85rem; letter-spacing: 1px; display: flex; align-items: center;
  gap: 8px; opacity: 0; pointer-events: none; transition: opacity 0.3s, transform 0.3s;
  z-index: 10000; box-shadow: 0 6px 20px rgba(46,204,113,0.4);
}
.copy-toast.show { opacity: 1; transform: translateX(-50%) translateY(0); }
</style>
